<!--智能推送-->
<template>
  <div>
    <a-card class="all-card-style ">
      <a-button type="primary" html-type="button" @click="showModal">
          新增
      </a-button>
      <!--      表格-->
      <div >
        <a-table :columns="columns" :data-source="taskDataList.dataList">
             <span slot="action" slot-scope="text, record">
            <a @click="editModel(record)">查询配置</a>
               <a-divider type="vertical"/>
        <a @click="handleDelete(record)">删除</a>
          </span>
        </a-table>
      </div>
    </a-card>

    <!--弹出框-->
    <a-modal v-model="modalVisible" title="智能推送" @ok="Save" @cancel="modalCancel" :maskClosable="false" ok-text="确认" cancel-text="取消">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-form-model-item  label="任务名称">
          <a-input type="text" autocomplete="off" v-model="taskData.task.cTaskName"/>
        </a-form-model-item>
        <a-form-model-item  label="任务类型">
          <a-radio-group  v-model="taskData.task.cTaskType" @change="taskTypeChange" >
            <a-radio-button v-for="(item,index) in taskType" :key="index" :value="item.value">{{item.name}}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="taskData.task.cTaskType!='离线'"  :label="taskTypeTitle">
          <a-select v-model="taskData.task.Params.identifier.key"  >

            <a-select-option v-for="(item,index) in proSelectItems" :key="index" :value="item.key">
              {{item.value}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item  v-if="taskData.task.cTaskType=='数据'" label="上限">
          <a-input-number  v-model="taskData.task.Params.max"  />
        </a-form-model-item>

        <a-form-model-item v-show="taskData.task.cTaskType=='数据'" label="下限">
          <a-input-number   v-model="taskData.task.Params.min"   />
        </a-form-model-item>
        <a-form-model-item v-show="taskData.task.cTaskType=='控制'" label="控制" >
          <a-radio-group   v-model="taskData.task.Params.max"  >
            <a-radio-button v-for="(item,index) in controlOptions" :key="index" :value="item.value">{{item.name}}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-show="taskData.task.cTaskType=='报警'" label="报警">
          <a-radio-group v-model="taskData.task.Params.max"  >
            <a-radio-button v-for="(item,index) in eventOptions" :key="index" :value="item.value">{{item.name}}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item  label="通知方式">
          <a-radio-group v-model="taskData.task.cSendType"  >
            <a-radio-button v-for="(item,index) in plainOptions" :key="item.value" :value="item.value">{{item.name}}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item  label="通知联系人">
          <a-checkbox-group
            v-model="taskData.task.SendTaskUsers"
            name="checkboxgroup"
            :options="userData.checkboxList"
            @change="userDataListCheck"
          />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';


  const columns = [
    {
      title: '任务名称',
      dataIndex: 'cTaskName',
      key: 'cTaskName',
    },
    {
      title: '任务类型',
      dataIndex: 'cTaskType',
      key: 'cTaskType',
    },
    {
      title: '通知类型',
      dataIndex: 'cSendType',
      key: 'cSendType',
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];

  const data = [
    {
      key: '1',
      eName:'溶解氧传感器',
      name:'任务一',
    },
    {
      key: '2',
      eName:'溶解氧传感器',
      name:'任务一',
    },
    {
      key: '3',
      eName:'溶解氧传感器',
      name:'任务一',
    },

    {
      key: '4',
      eName:'溶解氧传感器',
      name:'任务一',
    },

    {
      key: '5',
      eName:'溶解氧传感器',
      name:'任务一',
    },
  ];





  const plainOptionsCheck = ['林一', '李逵', '贾宝玉'];

  export default {
    name: 'intelligentPushList',
    components: {

    },
    data() {
      return {
        columns,
        data,
        modalVisible:false,
        taskType: [{value:'数据',name:'数据'}, {value:'控制',name:'控制'}, {value:'报警',name:'报警'},{value:'离线',name:'离线'}],
        taskTypeDefault: '数据',
        taskTypeTitle:'传感器',
        plainOptions:[{value:'小程序',name:'小程序'}, {value:'邮件',name:'邮件'}],
        plainOptionsDefault: '小程序',
        controlOptions:[{value:1,name:'开'}, {value:0,name:'关'}],

        eventOptions:[{value:1,name:'启用'},{value:0,name:'未启用'}],

        value: 3,
        value2: [],
        plainOptionsCheck,
        IotId:'',
        proSelectItems:[],
        taskDataList:{
          queryInfoList:{
            keyword:"",
          productkey:"",
            devicename:""

          },
          dataList:[]
        },
        userData:{
          queryInfo:{
            keyword:""
          },
          dataList:[],
          checkboxList:[]
        },
        deviceData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            limit:1

          },
          devices:{},
          proDataTime:"",
          propertiesR:[],
          propertiesW:[],
          events:[],
          dataList:[],
          timer: '',//定时器
          timerList:''
        },
        taskData:{
          queryInfo:{
            keyword:"",
            productKey:"",
            deviceName:"",
            page:1,
            limit:10
          },
          task:{
            ID:'',
            cTaskName:'',
            cTaskType:'',
            cSendType:'',
            Params:{
              productKey:"",
              deviceName:"",
              iotId:"",
              identifier:{
                key:'',
                value:''
              },
              max:1,
              min:0
            },
            SendTaskUsers:[]
          },
          dataList:[]
        }
      }
    },

    async  mounted() {

      this.IotId=this.$route.query.IotId


      let res = await this.$http.post('WLWDevice/List', {
        cSystemCode:'节水灌溉',
        cEntID:this.$store.getters.User.enterprise.ID
      })
      //  sceneId: this.$store.getters.SCene.ID  ,
      var device=res.data.obj.list;
      device=device.filter(x=>x.IotId==this.IotId)[0]


      if(device!=null) this.deviceData.devices=device

      var ThingModel=this.$store.getters.ThingModels.filter(x=>x.productKey==this.deviceData.devices.ProductKey)[0]
      if(ThingModel!=null) {
        this.deviceData.propertiesR=this.utils.deepClone(ThingModel.propertiesR)
        this.deviceData.propertiesW=this.utils.deepClone(ThingModel.propertiesW)
        this.deviceData.events=this.utils.deepClone(ThingModel.events)

        this.deviceData.propertiesR.forEach(element=>{
          var item={
            key:element.identifier,
            value:element.name
          }
          this.proSelectItems.push(item)

        })
        if(this.proSelectItems.length>0) {
          this.taskData.task.Params.identifier=this.proSelectItems[0]

        }
      }
      this.taskData.task.cTaskType=this.taskTypeDefault
      this.taskData.task.cSendType=this.plainOptionsDefault



      this.taskDataList.queryInfoList.productkey=this.deviceData.devices.ProductKey;
      this.taskDataList.queryInfoList.devicename=this.deviceData.devices.DeviceName
       this.getUserList()
      this.getPageList()
    },
    methods:{
      async getPageList(){
        let that=this;
        that.taskDataList.queryInfoList .cSystemCode='节水灌溉';
        let {data:res} = await that.$http.post('EntWLWDeviceAutoSendTask/List',that.taskDataList.queryInfoList)
        if(res.code=="200"){
          that.taskDataList.dataList= res.obj.list
        }
        else{
        }
      },
      showModal(){
        this.modalVisible=true
        this.taskData.task={
          ID:'',
          cTaskName:'',
          cTaskType:'',
          cSendType:'',
          cSystemCode:'节水灌溉',
          Params:{
            productKey:"",
            deviceName:"",
            iotId:"",
            identifier:{
              key:'',
              value:''
            },
            max:1,
            min:0
          },
          SendTaskUsers:[]
        };

      },
    async  editModel(record){
        this.modalVisible=true;
        this.taskData.task.ID=record.ID;
        const {data:res} = await this.$http.post('EntWLWDeviceAutoSendTask/FindById/'+this.taskData.task.ID,null)
        if(res.code=="200"){
          this.taskData.task= res.obj.data
          this.proSelectItems.splice(0)
          if(this.taskData.task.cTaskType=='数据'){
            this.taskTypeTitle='传感器'
            this.proSelectItems=[];
            this.taskData.task.Params.identifier.key='';
            this.deviceData.propertiesR.forEach(element=>{
              var item={
                key:element.identifier,
                value:element.name
              }
              this.proSelectItems.push(item)
            })
          }
          else if(this.taskData.task.cTaskType=='控制'){
            this.taskTypeTitle='执行器'
            this.proSelectItems=[];
            this.taskData.task.Params.identifier.key='';
            this.deviceData.propertiesW.forEach(element=>{
              var item={
                key:element.identifier,
                value:element.name
              }
              this.proSelectItems.push(item)
            })
          }
          else if(this.taskData.task.cTaskType=='报警'){
            this.taskTypeTitle='报警事件'
            this.proSelectItems=[];
            this.taskData.task.Params.identifier.key='';
            this.deviceData.events.forEach(element=>{
              var item={
                key:element.identifier,
                value:element.eventName
              }
              this.proSelectItems.push(item)
            })
          }else if(this.taskData.task.cTaskType=='离线')
          {

            this.taskTypeTitle=''
            this.proSelectItems=[];
            this.taskData.task.Params.identifier.key='';
          }
          if(this.proSelectItems.length>0) {
            this.taskData.task.Params.identifier=this.proSelectItems[0]

          }
        }
      },
      async handleDelete(record){
        let that=this;
        let param=null;
        let res=await that.$http.post('EntWLWDeviceAutoSendTask/Delete?ids='+record.ID,param)
        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.getPageList();
        }
        else{
          that.$message.error(res.message)

        }
      },

      async getUserList(){
        let that=this;
          let {data:res} = await that.$http.post('User/List',that.userData.queryInfo)

        if(res.code=="200"){
          that.userData.dataList= res.obj.list
            this.userData.checkboxList=res.obj.list.map(item=>{ return item.cUserCode+'('+item.cUserName+')' })
        }

      },
      taskTypeChange(e){
        this.$set(this.taskData.task,"cTaskType",e.target.value);
        this.proSelectItems.splice(0)
        if(e.target.value=='数据'){
          this.taskTypeTitle='传感器'
          this.proSelectItems=[];
          this.taskData.task.Params.identifier.key='';
          this.deviceData.propertiesR.forEach(element=>{
            var item={
              key:element.identifier,
              value:element.name
            }
            this.proSelectItems.push(item)
          })
        }
        else if(e.target.value=='控制'){
          this.taskTypeTitle='执行器'
          this.proSelectItems=[];
          this.taskData.task.Params.identifier.key='';
          this.deviceData.propertiesW.forEach(element=>{
            var item={
              key:element.identifier,
              value:element.name
            }
            this.proSelectItems.push(item)
          })
        }
        else if(e.target.value=='报警'){
          this.taskTypeTitle='报警事件'
          this.proSelectItems=[];
          this.taskData.task.Params.identifier.key='';
          this.deviceData.events.forEach(element=>{
            var item={
              key:element.identifier,
              value:element.eventName
            }
            this.proSelectItems.push(item)
          })
        }else if(e.target.value=='离线')
        {

          this.taskTypeTitle=''
          this.proSelectItems=[];
          this.taskData.task.Params.identifier.key='';
        }
        if(this.proSelectItems.length>0) {
          this.taskData.task.Params.identifier=this.proSelectItems[0]

        }
      },
      plainOptionsChange(e){
        this.taskData.task.cSendType=e.target.value
      },
      controlsOptionsChange(e){

      },
      eventOptionsChange(e){

      },
      userDataListCheck(checkedValues){
        this.taskData.task.SendTaskUsers=checkedValues
      },
      async Save(){
        this.taskData.task.Params.iotId=this.$route.query.IotId
        this.taskData.task.Params.productKey=this.deviceData.devices.ProductKey
        this.taskData.task.Params.deviceName=this.deviceData.devices.DeviceName
        const {data:res} = await this.$http.post('EntWLWDeviceAutoSendTask/Save',this.taskData.task)
        if(res.code=="200"){
            this.$message.success(res.message)
          this.modalVisible=false
          this.getPageList();
        }
        else{
          this.$message.error(res.message)
        }
      },
      modalCancel(){
        this.modalVisible=false
      },
    },


  }
</script>


<style>
  @import "../equipmentDetailsStyle.css";
</style>


